import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Calendar, Heart, Star, MessageSquare, Settings as SettingsIcon } from 'lucide-react';

const MobileLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const navItems = [
    { icon: Calendar, label: 'Calendar', path: '/reminders', testId: 'nav-reminders' },
    { icon: Heart, label: 'Mood', path: '/moodsync', testId: 'nav-moodsync' },
    { icon: Star, label: 'Brownies', path: '/brownies', testId: 'nav-brownies' },
    { icon: MessageSquare, label: 'Resolve', path: '/conflict', testId: 'nav-conflict' },
    { icon: SettingsIcon, label: 'Settings', path: '/settings', testId: 'nav-settings' },
  ];
  
  return (
    <div className="min-h-[100dvh] bg-white flex flex-col">
      {/* Main content area - scrollable */}
      <div className="flex-1 max-w-lg mx-auto w-full overflow-y-auto pb-20 native-scroll">
        <div className="page-transition">
          {children}
        </div>
      </div>
      
      {/* iOS-style bottom navigation - fixed */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white/95 ios-blur border-t border-gray-100 z-50">
        <div className="max-w-lg mx-auto safe-bottom">
          <div className="flex justify-around items-center h-14">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <button
                  key={item.path}
                  data-testid={item.testId}
                  onClick={() => navigate(item.path)}
                  className={`flex flex-col items-center justify-center w-16 h-full tap-nav ${
                    isActive
                      ? 'text-primary'
                      : 'text-gray-400'
                  }`}
                >
                  <Icon 
                    className={`w-5 h-5 transition-transform duration-200 ${isActive ? 'scale-110' : ''}`} 
                    strokeWidth={isActive ? 2.5 : 2}
                    fill={isActive ? 'currentColor' : 'none'} 
                  />
                  <span className={`text-[10px] mt-0.5 font-medium ${isActive ? 'text-primary' : 'text-gray-500'}`}>
                    {item.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default MobileLayout;
